import React, { useEffect, useState } from 'react';
import styles from './DefaultLoader.module.css';

interface DefaultLoaderProps {
  className?: string;
  messages?: string[];
  title?: string;
}

const defaultMessages = [
  'Carregando dados...',
  'Processando informações...',
  'Quase pronto...',
];

export default function DefaultLoader({
  className,
  messages = defaultMessages,
  title = 'Carregando',
}: DefaultLoaderProps) {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    const messageInterval = setInterval(() => {
      setCurrentMessageIndex(prev => (prev + 1) % messages.length);
    }, 2500);

    return () => {
      clearInterval(messageInterval);
    };
  }, [messages.length]);

  return (
    <div className={`${styles.container} ${className || ''}`}>
      <div className={styles.contentWrapper}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            {title}
          </h2>
        </div>

        <div className={styles.animationContainer}>
          <div className={styles.spinner}></div>
        </div>

        <div className={styles.messageContainer}>
          <p className={styles.message}>
            {messages[currentMessageIndex]}
          </p>
        </div>

        <div className={styles.loadingDots}>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
        </div>
      </div>
    </div>
  );
}
